import React from "react";
import "./Login.css";
import Logo from "../../../img/logo.png";
import { css } from "@emotion/react";
// First way to import
import { ScaleLoader } from "react-spinners";
import { Link } from "react-router-dom";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

export default function Login(props) {
  // let value=(this.props.pass) ? undefined : "";
  return (
    <div>
      <div className="container">
        <div id="main-outer-div">
          <div id="logo-div">
            <img id="logo-img" src={Logo} alt="" />
          </div>
          <div id="title-div">
            <h4 className="title">SIGN IN EMPLOYEE</h4>
          </div>

          <div id="outer-login-form-div">
            <form action="" method="" onSubmit={props.onSubmit}>
              {/* <div className="form-group"> */}
              <input
                className="login-form-input"
                type="text"
                // className="form-control"
                placeholder="Email"
                required="required"
                name="Username"
              />
              {/* </div> */}
              {/* <div className="form-group"> */}
              <input
                className="login-form-input"
                type="password"
                // className="form-control"
                placeholder="Password"
                required="required"
              />
              {/* </div> */}
              {/* <div className="form-group"> */}
              <input
                className="login-form-input"
                type="submit"
                // className="btn btn-primary btn-block btn-lg btn-mystyle"
                value="SIGN IN"
                id="submitBtn"
              />
              {/* </div> */}
              {!props.pass ? (
                <p className="alert">Invalid UserName or Password</p>
              ) : (
                ""
              )}
            </form>
          </div>

          <div className="loading">
            <ScaleLoader
              css={override}
              sizeUnit={"px"}
              size={150}
              color={"#123abc"}
              loading={props.loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
